import Contact from '@/components/contact/Contact';
import React from 'react';

export default function _Imprint() {
  return <Contact />;
}
